(function(){
  if(window.__formulaBgInit) return; window.__formulaBgInit=true;
  function apply(){
    var el=document.querySelector('.x-block-product-sibling[data-current-formula]');
    var f=el?el.getAttribute('data-current-formula'):'';
    var b=document.body; b.classList.remove('formula-active','formula-herbal');
    if(f==='active'||f==='herbal') b.classList.add('formula-'+f);
  }
  var mc=document.getElementById('MainContent');
  if(mc){var tt;var mo=new MutationObserver(function(){clearTimeout(tt);tt=setTimeout(apply,60);});mo.observe(mc,{childList:true,subtree:true});}
  if(document.readyState!=='loading')apply();else document.addEventListener('DOMContentLoaded',apply);
})();